export default (state = [], action) => {
  switch (action.type){
    case 'GET_ALERTS':
		//console.log("reducer GET_ALERTS: " + JSON.stringify(action.alerts));
		return action.alerts;
			break;
	case 'GET_ALERT':
		//console.log("reducer GET_ALERT[1]: " + JSON.stringify(action.oneAlert));
		var newState=[];
		for(let i=0; i<state.length; i++){
			if(state[i].id!==action.oneAlert.id){
				newState.push(state[i]);
			}else{
				newState.push(action.oneAlert);
			}
		}
		//console.log("reducer GET_ALERT[2]: " + JSON.stringify(newState));
		return newState;
			break;
    default:
        return state;
  }
};